import { IQueryContext } from 'framework/context/IQueryContext';
import { IGeneralPractitioner, IGeneralPractitionersQueryParams, IQueryResult } from 'gen/ApiClient';
import React from 'react';

export const GeneralPractitionersQueryContext = React.createContext<IQueryContext<IQueryResult<IGeneralPractitioner>, IGeneralPractitionersQueryParams>>(
	undefined as any
);
